import { render, staticRenderFns } from "./NastereNaturala.vue?vue&type=template&id=4de43331&scoped=true&"
import script from "./NastereNaturala.vue?vue&type=script&lang=js&"
export * from "./NastereNaturala.vue?vue&type=script&lang=js&"
import style0 from "./NastereNaturala.vue?vue&type=style&index=0&id=4de43331&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de43331",
  null
  
)

export default component.exports